import React from "react";
import ShareView from "./ShareView";
import EmbedView from "./EmbedView";
import { isEmbedMode } from "../../data/shareRouting";

/**
 * The single entry point wired to the `/share/<id>` route. One route, one loader,
 * two presentations: chrome-less {@link EmbedView} inside an iframe (or with an
 * explicit `?embed=1`), otherwise the standalone {@link ShareView} chrome.
 *
 * The decision is made once here, up front, so only one presentation ever
 * mounts (and its `useShareFile` loader runs once).
 */
export const ShareRoute: React.FC = () => {
  return isEmbedMode() ? <EmbedView /> : <ShareView />;
};

export default ShareRoute;
